import { render, staticRenderFns } from "./CLCards.vue?vue&type=template&id=e48e73b8&scoped=true"
import script from "./CLCards.vue?vue&type=script&lang=js"
export * from "./CLCards.vue?vue&type=script&lang=js"
import style0 from "./CLCards.vue?vue&type=style&index=0&id=e48e73b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48e73b8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DSIcon: require('/build/node_modules/@lamiaoy/st1-ds-components/src/components/Components/Icon/Icon.vue').default,Button: require('/build/src/components/elements/Button.vue').default,DSFrontifyAsset: require('/build/node_modules/@lamiaoy/st1-ds-components/src/components/Components/FrontifyAsset/FrontifyAsset.vue').default,DSCFText: require('/build/node_modules/@lamiaoy/st1-ds-components/src/components/Components/CFText/CFText.vue').default,DSLink: require('/build/node_modules/@lamiaoy/st1-ds-components/src/components/Components/Link/Link.vue').default})
